// Marksmith (GitHub-style markdown editor) Stimulus controllers. These ship from
// the @avo-hq/marksmith npm package, NOT local files, so they aren't picked up by
// `stimulus:manifest:update` (which regenerates controllers/index.js from local
// controllers). Registered here and imported from application.js so the manifest
// regeneration never clobbers them.
import { application } from "./application"
import { MarksmithController, ListContinuationController } from "@avo-hq/marksmith"

application.register("marksmith", MarksmithController)
application.register("list-continuation", ListContinuationController)
